import { render } from "./CustomSelectItemReason.vue?vue&type=template&id=26ed6594&ts=true"
import script from "./CustomSelectItemReason.vue?vue&type=script&lang=ts"
export * from "./CustomSelectItemReason.vue?vue&type=script&lang=ts"

import "./CustomSelectItemReason.vue?vue&type=style&index=0&id=26ed6594&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__